import React from "react";

export default function NotFound() {
    return (
        <div>
            Requested page not found
        </div>
    );
}
